// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { V1ClusterConditionStatus } from './V1ClusterConditionStatus';
import {
  V1ClusterConditionStatusFromJSON,
  V1ClusterConditionStatusFromJSONTyped,
  V1ClusterConditionStatusToJSON,
  V1ClusterConditionStatusToJSONTyped,
} from './V1ClusterConditionStatus';

/**
 *
 * @export
 * @interface V1ClusterCondition
 */
export interface V1ClusterCondition {
  /**
   *
   * @type {V1ClusterConditionStatus}
   * @memberof V1ClusterCondition
   */
  status?: V1ClusterConditionStatus;
  /**
   *
   * @type {string}
   * @memberof V1ClusterCondition
   */
  type?: string;
}

/**
 * Check if a given object implements the V1ClusterCondition interface.
 */
export function instanceOfV1ClusterCondition(
  value: object,
): value is V1ClusterCondition {
  return true;
}

export function V1ClusterConditionFromJSON(json: any): V1ClusterCondition {
  return V1ClusterConditionFromJSONTyped(json, false);
}

export function V1ClusterConditionFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): V1ClusterCondition {
  if (json == null) {
    return json;
  }
  return {
    status:
      json['status'] == null
        ? undefined
        : V1ClusterConditionStatusFromJSON(json['status']),
    type: json['type'] == null ? undefined : json['type'],
  };
}

export function V1ClusterConditionToJSON(json: any): V1ClusterCondition {
  return V1ClusterConditionToJSONTyped(json, false);
}

export function V1ClusterConditionToJSONTyped(
  value?: V1ClusterCondition | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    status: V1ClusterConditionStatusToJSON(value['status']),
    type: value['type'],
  };
}
